export default function loadJS(url: string) {
  return new Promise((resolve, reject) => {
    const UIScript = document.createElement('script');
    const src = `${url}`;
    UIScript.src = src;
    UIScript.type = 'text/javascript';
    UIScript.async = true;
    document.head.appendChild(UIScript);
    UIScript.onload = () => {
      setTimeout(resolve, 0);
    };
    UIScript.onerror = () => reject();
  });
}

export function loadCss(url: string) {
  const css = document.createElement('link');
  css.href = url;
  css.rel = 'stylesheet';
  css.type = 'text/css';
  document.head.appendChild(css);
}
